import { Component, Input, OnInit, ViewEncapsulation } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Country, OccSiteAdapter, TranslationService } from '@spartacus/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { Observable } from 'rxjs';
import { tap } from 'rxjs/operators';
import { AtgContactUsService } from './atg-contact-us.service';

@Component({
  selector: 'atg-contact-us-dialog',
  templateUrl: './atg-contact-us-dialog.component.html',
  styleUrl: './atg-contact-us-dialig.component.scss',
  providers: [OccSiteAdapter],
  encapsulation: ViewEncapsulation.None,
  standalone: false,
})
export class AtgContactUsDialogComponent implements OnInit {
  @Input() sendEmailTo: string = '';

  countries$!: Observable<Country[]>;
  isCountryLoading = false;

  reasonOptions = [
    { value: 'UNABLE_TO_LOGIN', label: 'AtgContactUs.reasons.unableToLogin' },
    { value: 'ACCOUNT_LOCKED', label: 'AtgContactUs.reasons.accountLocked' },
    { value: 'TECHNICAL_ISSUE', label: 'AtgContactUs.reasons.technicalIssue' },
    { value: 'CUSTOMER_SERVICE', label: 'AtgContactUs.reasons.customerService' },
    { value: 'OTHER', label: 'AtgContactUs.reasons.other' },
  ];

  contactForm!: FormGroup;

  isSubmitting = false;
  submitError = false;
  submitSuccess = false;
  successMessage = '';

  constructor(
    private activeModal: NgbActiveModal,
    private fb: FormBuilder,
    private occSiteAdapter: OccSiteAdapter,
    private contactUsService: AtgContactUsService,
    private translationService: TranslationService
  ) {}

  ngOnInit(): void {
    this.contactForm = this.fb.group({
      form: ['', Validators.required],
      reason: ['', Validators.required],
      userCountry: ['', Validators.required],
      subject: ['', [Validators.required, Validators.maxLength(250)]],
      message: ['', [Validators.required, Validators.maxLength(400)]],
    });
    this.getCountries();
  }

  getCountries(): void {
    this.isCountryLoading = true;
    this.countries$ = this.occSiteAdapter.loadCountries().pipe(
      tap(() => (this.isCountryLoading = false))
    );
  }

  get f() {
    return this.contactForm.controls;
  }

  onSubmit(): void {
    if (this.contactForm.invalid) {
      this.contactForm.markAllAsTouched();
      return;
    }
    const { form, reason,  userCountry, subject, message } = this.contactForm.value;
    const selectedReasonOption = this.reasonOptions.find(option => option.value === reason);

    if (selectedReasonOption) {
      this.translationService.translate(selectedReasonOption.label).subscribe(translatedReason => {
        this.isSubmitting = true;
        this.submitError = false;
        this.contactUsService.submit({
          fromName: form,
          reason: translatedReason,
          country: userCountry,
          subject,
          message,
        }).subscribe({
          next: (res) => {
            this.isSubmitting = false;
            this.successMessage = res.message;
            this.submitSuccess = true;
          },
          error: () => {
            this.isSubmitting = false;
            this.submitError = true;
          },
        });
      });
    }
  }

  dismiss(): void {
    this.activeModal.dismiss();
  }
}
